<template>
	<v-card>
			<v-card-title>Confirm Your Settings for this Meeting</v-card-title>
			<v-card-text>
				<v-alert  icon="mdi-shield-lock-outline" dense text type="info" v-if="!accessConfirmed">
					<small>Please wait to be admitted to this session. </small>
				</v-alert>
				<v-text-field v-model="screenName" label="Enter your name as you’d like it to appear to other participants"></v-text-field>
				<div v-if="accessConfirmed">
					<!-- <p>Join with:</p> -->
					<IncognitoButton v-if="view !== 'panelmember'" :room="room" v-bind="participant"></IncognitoButton>
						<span v-if="view !== 'panelmember'">
						Incognito mode - The moderator for this session will know you’ve joined, but other participants won’t (you can change this later)<br/>
					</span>
					<AVSettings :room="room" :settings="participant">
						<template v-slot:audioText>
							Mute your microphone - Other participants won’t hear you (You can change this later)<br/>
						</template>
						<template v-slot:videoText>
							Mute your camera - Other participants will see a grey screen (You can change this later)<br/>
						</template>
					</AVSettings>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green" dark v-if="accessConfirmed" @click="join">Join</v-btn>
			</v-card-actions>
		</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import IncognitoButton from "./IncognitoButton"
	import AVSettings from "./AVSettings"
	export default {
		name: "PreScreen", 
		components: {
			AVSettings,
			IncognitoButton
		},
		computed: {
			...Vuex.mapState( {
				view: state => state.auth.view,
				user: state => state.auth.user,
				participant: state => state.video.participant, 
				participants: state => state.video.participats,
			}),
		},
		props: {
			room: {},
			accessConfirmed: { type: Boolean }
		},
		data: () => {
			return {
				screenName: ""
			}
		},
		watch: {
			user: {
				handler(user){
					if( user.displayName ){
						this.screenName = user.displayName
					}
				}
			},
			screenName: {
				handler(){				
					if( this.participant && this.screenName.length > 0 ){
						this.$store.dispatch("updateDoc", {
							doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
							data: {
								screenName: this.screenName,
							},
							action: "update"
						})
					}
				}
			}
		},
		methods: {
			join(){
				var settings = {
					screenName: this.screenName
				};
				this.$emit("join", settings )
			}
		}
	}
// </script>"